import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { View } from "react-native";
import NativeBlur from "../specs/OneNativeBlurNativeComponent";
function Blur(props) {
  var { intensity = 50, tint = "default", style, children, ...viewProps } = props;
  return /* @__PURE__ */ _jsxs(View, {
    style: [
      {
        backgroundColor: "transparent"
      },
      style
    ],
    ...viewProps,
    children: [
      /* @__PURE__ */ _jsx(NativeBlur, {
        tint,
        intensity: Math.max(0, Math.min(1, intensity / 100)),
        style: {
          position: "absolute",
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        }
      }),
      children
    ]
  });
}
export {
  Blur
};
//# sourceMappingURL=Blur.native.js.map
